import { ControlValueAccessor, FormBuilder } from '@angular/forms';
import { AfterViewInit, Component, effect, inject, input } from '@angular/core';

@Component({ template: '' })
export class AbstractFormControlComponent<T> implements ControlValueAccessor, AfterViewInit {
  protected formBuilder = inject(FormBuilder);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = (_: unknown) => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  constructor() {
    effect(() => {
      if (!this.isDisabled()) {
        this.internalControl.enable();
        return;
      }

      this.internalControl.disable();
    });
  }

  ngAfterViewInit() {
    this.internalControl.valueChanges.subscribe((value) => {
      this.onInternalControlValueChange(value);
    });
  }

  readonly isDisabled = input<boolean>(false);

  internalControl = this.formBuilder.control<null | T>(null);

  writeValue(value: T): void {
    this.internalControl.setValue(value, { emitEvent: false });
  }
  registerOnChange(fn: never): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: never): void {
    this.onTouched = fn;
  }

  onInternalControlValueChange(value: T | null) {
    this.onChange(value);
    this.onTouched();
  }
}
